"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const spinner_interceptor_1 = __importDefault(require("../interceptors/spinner.interceptor"));
const auth_token_iw_interceptor_1 = __importDefault(require("../interceptors/auth-token-iw.interceptor"));
const http = axios_1.default.create({
    baseURL: window.location.origin,
    headers: {
        "Content-Type": "application/json"
    }
});
auth_token_iw_interceptor_1.default.wrapAxios(http);
spinner_interceptor_1.default.wrapAxios(http);
function fetchIWVenueVendors(venueId, reqBody) {
    return http.post(`/venues/${venueId}/vendors`, reqBody, {
        showSpinner: true,
        applyToken: true
    });
}
function fetchIWVenueVendorById(venueId, vendorId) {
    return http.get(`/venues/${venueId}/vendors/${vendorId}`, {
        showSpinner: true,
        applyToken: true
    });
}
function fetchIWVenueVendorPickupTimes(venueId, vendorId) {
    return http.get(`/venues/${venueId}/vendors/${vendorId}/pickup-times`, {
        showSpinner: true,
        applyToken: true
    });
}
function fetchIWDeepLinkVendors(venueId, reqBody) {
    return http.post(`/venues/${venueId}/vendors/deep-link`, reqBody, {
        showSpinner: true,
        applyToken: true
    });
}
exports.default = {
    fetchIWVenueVendors,
    fetchIWVenueVendorById,
    fetchIWDeepLinkVendors,
    fetchIWVenueVendorPickupTimes
};
